import { useEffect, useState } from 'react';
import { api } from '../utils/api';
import { useAuthStore } from '../stores/authStore';
export function useHubResource<T>(path: string) {
  const userId = useAuthStore(state => state.user?.id);
  const [revision, setRevision] = useState(0);
  const [result, setResult] = useState<{ data: T | null; state: 'loading' | 'ready' | 'error' | 'denied' }>({ data: null, state: 'loading' });
  useEffect(() => {
    const controller = new AbortController();
    setResult({ data: null, state: 'loading' });
    api.get<T>(path, { signal: controller.signal, timeout: 5000 }).then(({ data }) => { if (!controller.signal.aborted) setResult({ data, state: 'ready' }); }).catch(error => { if (!controller.signal.aborted) setResult({ data: null, state: error.status === 403 ? 'denied' : 'error' }); });
    return () => controller.abort();
  }, [path, userId, revision]);
  return { ...result, retry: () => setRevision(value => value + 1) };
}
